'use memo'

import React from 'react'
import type { OperationsNode } from '@sportninja/common/features/competition/operations/types/operations.types'
import Breadcrumb from 'src/components/ts-components/Breadcrumb'

interface PanelBreadcrumbProps {
  ancestors: OperationsNode[]
  /** The selected node — the trailing crumb, not clickable. */
  current: OperationsNode
  /** Selects a crumb's node in the tree. */
  onSelectNode: (nodeId: string) => void
}

/**
 * Crumbs select their node in the tree rather than navigating away — the rail
 * holds selection and expansion state the user would otherwise lose, and the
 * panel already renders whatever the tree has selected.
 */
const PanelBreadcrumb = ({
  ancestors,
  current,
  onSelectNode,
}: PanelBreadcrumbProps) => {
  // The organization and the root season are both already in the screen header
  // above this panel, so repeating them here is noise. `ancestors` runs
  // root-first, which makes the season the entry to drop.
  const crumbs = ancestors.filter((ancestor) => ancestor.type !== 'season')

  // With the org and season gone, a season or conference selection has nothing
  // left to show but its own name — which is the panel title directly below.
  if (crumbs.length === 0) {
    return null
  }

  return (
    <Breadcrumb
      items={[
        ...crumbs.map((ancestor) => ({
          key: ancestor.id,
          label: ancestor.name,
          onSelect: () => onSelectNode(ancestor.id),
        })),
        { key: current.id, label: current.name },
      ]}
    />
  )
}

export default PanelBreadcrumb
